// import React from 'react';
// import { X, Cpu, HardDrive, Zap, Server, CheckCircle, Lock, Fan, CircuitBoard } from 'lucide-react';
// // Ensure this path matches where you saved the large HARDWARE_ITEMS array
// import { HARDWARE_ITEMS } from '../data/hardware'; 

// const HardwareShop = ({ balance, inventory, equipped, onBuy, onEquip, onClose }) => {

//   // Updated categories to match your new data file
//   const categories = ['cpu', 'gpu', 'ram', 'psu', 'mobo', 'fan'];

//   const getIcon = (type) => {
//     switch (type) {
//       case 'cpu': return <Cpu size={20} />;
//       case 'gpu': return <Server size={20} />;
//       case 'ram': return <HardDrive size={20} />;
//       case 'psu': return <Zap size={20} />;
//       case 'mobo': return <CircuitBoard size={20} />;
//       case 'fan': return <Fan size={20} />;
//       default: return <Server size={20} />;
//     }
//   };

//   return (
//     <div className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-md flex justify-center items-center p-4 animate-in fade-in duration-200">

//       <div className="bg-slate-900 border-2 border-slate-700 w-full max-w-4xl h-[85vh] rounded-3xl flex flex-col overflow-hidden shadow-2xl relative">

//         {/* HEADER */}
//         <div className="p-6 border-b border-slate-700 flex justify-between items-center bg-slate-950">
//           <div>
//             <h2 className="text-2xl font-black text-white uppercase tracking-widest flex items-center gap-3">
//               <Server className="text-cyan-400" /> System Rig
//             </h2>
//             <p className="text-slate-400 text-xs font-mono mt-1">Upgrade hardware to boost multipliers & luck.</p>
//           </div>

//           <div className="flex items-center gap-4">
//             {/* Balance Display (Money) */}
//             <div className="bg-black px-4 py-2 rounded-lg border border-yellow-600/50 text-yellow-400 font-mono font-bold shadow-[0_0_15px_rgba(234,179,8,0.2)]">
//               ${balance.toLocaleString()}
//             </div>

//             <button onClick={onClose} className="bg-slate-800 hover:bg-red-900/50 p-2 rounded-full transition-colors border border-slate-700 hover:border-red-500">
//               <X className="text-white" />
//             </button>
//           </div>
//         </div>

//         {/* CONTENT */}
//         <div className="flex-1 overflow-y-auto p-6 scrollbar-hide bg-[#050505]">
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

//             {categories.map((cat) => {
//               // Filter items for this category
//               const items = HARDWARE_ITEMS.filter(item => item.type === cat);
//               if (items.length === 0) return null;

//               return (
//                 <div key={cat} className="space-y-4">
//                   <h3 className="text-slate-500 font-bold uppercase text-xs tracking-[0.2em] mb-2 border-b border-slate-800 pb-2 flex items-center gap-2">
//                     {getIcon(cat)} {cat.toUpperCase()} Modules
//                   </h3>

//                   {items.map((item) => {
//                     const isOwned = inventory.includes(item.id);
//                     const isEquipped = equipped[item.type] === item.id;

//                     // FIX: Use item.cost directly. Do NOT multiply by 2000.
//                     const price = item.cost; 
//                     const canAfford = balance >= price;

//                     return (
//                       <div 
//                         key={item.id} 
//                         className={`relative p-4 rounded-xl border-2 transition-all group
//                           ${isEquipped 
//                             ? 'bg-cyan-950/30 border-cyan-500 shadow-[0_0_15px_rgba(6,182,212,0.15)]' 
//                             : 'bg-slate-900/50 border-slate-800 hover:border-slate-600'}
//                         `}
//                       >
//                         <div className="flex justify-between items-start mb-2">
//                           <div className="flex items-center gap-3">
//                             <div className={`p-2 rounded-lg ${isEquipped ? 'bg-cyan-500 text-black' : 'bg-slate-800 text-slate-400'}`}>
//                               {getIcon(item.type)}
//                             </div>
//                             <div>
//                               <div className={`font-bold text-sm ${isEquipped ? 'text-cyan-100' : 'text-white'}`}>{item.name}</div>
//                               <div className="text-[10px] text-slate-400 font-mono mt-0.5">{item.effect}</div>
//                             </div>
//                           </div>
//                           {isEquipped && <CheckCircle className="text-cyan-400 w-5 h-5 drop-shadow-md" />}
//                         </div>

//                         <div className="mt-4 flex justify-between items-center">
//                           <div className="text-xs font-mono text-slate-600 uppercase tracking-wider">
//                              Tier {item.tier}
//                           </div>

//                           {isOwned ? (
//                             <button 
//                               onClick={() => onEquip(item)}
//                               disabled={isEquipped}
//                               className={`px-4 py-1.5 rounded text-[10px] font-bold uppercase tracking-wider transition-all border
//                                 ${isEquipped 
//                                   ? 'bg-transparent border-transparent text-cyan-600 cursor-default' 
//                                   : 'bg-slate-800 border-slate-600 hover:border-cyan-500 hover:text-cyan-400 text-slate-300'}
//                               `}
//                             >
//                               {isEquipped ? 'INSTALLED' : 'EQUIP'}
//                             </button>
//                           ) : (
//                             <button 
//                               onClick={() => onBuy(item, price)} 
//                               disabled={!canAfford}
//                               className={`px-4 py-1.5 rounded text-[10px] font-bold uppercase tracking-wider flex items-center gap-2 border
//                                 ${canAfford 
//                                   ? 'bg-yellow-600 border-yellow-500 hover:bg-yellow-500 text-black shadow-lg shadow-yellow-900/20' 
//                                   : 'bg-slate-900 border-slate-800 text-slate-600 cursor-not-allowed'}
//                               `}
//                             >
//                               {!canAfford && <Lock size={10} />}
//                               ${price.toLocaleString()}
//                             </button>
//                           )}
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               );
//             })}

//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default HardwareShop;


import React from 'react';
import { X, Cpu, HardDrive, Zap, Server, CheckCircle, Lock, Fan, CircuitBoard } from 'lucide-react';
// Ensure this path matches where you saved the large HARDWARE_ITEMS array
import { HARDWARE_ITEMS } from '../data/hardware';

const HardwareShop = ({ balance, inventory, equipped, onBuy, onEquip, onClose, discount }) => {

  // Updated categories to match your new data file
  const categories = ['cpu', 'gpu', 'ram', 'psu', 'mobo', 'fan'];

  const getIcon = (type) => {
    switch (type) {
      case 'cpu': return <Cpu size={20} />;
      case 'gpu': return <Server size={20} />;
      case 'ram': return <HardDrive size={20} />;
      case 'psu': return <Zap size={20} />;
      case 'mobo': return <CircuitBoard size={20} />;
      case 'fan': return <Fan size={20} />;
      default: return <Server size={20} />;
    }
  };

  return (
    <div className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-md flex justify-center items-center p-4 animate-in fade-in duration-200">

      {/* Main Container with intensified Cyan Glow border */}
      <div className="bg-[#0a0a0f] border-2 border-cyan-400/60 w-full max-w-5xl h-[85vh] rounded-3xl flex flex-col overflow-hidden shadow-[0_0_80px_rgba(6,182,212,0.3)] relative">

        {/* HEADER */}
        <div className="p-6 border-b-2 border-cyan-500/30 flex justify-between items-center bg-gradient-to-r from-cyan-950/50 to-[#0a0a0f]">
          <div>
            <h2 className="text-2xl font-black text-white uppercase tracking-widest flex items-center gap-3 drop-shadow-[0_0_15px_rgba(6,182,212,0.6)]">
              <Server className="text-cyan-300" size={28} /> CASINO System Rig TOOLS
            </h2>
            <p className="text-cyan-200/70 text-xs font-mono mt-2 font-bold">Upgrade hardware to boost multipliers & luck.</p>
          </div>

          <div className="flex items-center gap-4">
            {/* Balance Display (Money) */}
            <div className="bg-black/80 px-4 py-2 rounded-xl border-2 border-yellow-500/40 text-yellow-400 font-mono font-bold shadow-[0_0_25px_rgba(234,179,8,0.2)] flex items-center gap-2">
              <span className="text-yellow-600">$</span> {balance.toLocaleString()}
            </div>

            <button onClick={onClose} className="bg-slate-900/80 hover:bg-red-900/80 p-2 rounded-full transition-all border-2 border-slate-700 hover:border-red-500 text-slate-400 hover:text-white hover:shadow-[0_0_20px_rgba(239,68,68,0.4)]">
              <X size={20} />
            </button>
          </div>
        </div>

        {/* CONTENT */}
        <div className="flex-1 overflow-y-auto p-6 scrollbar-hide bg-[#050505] relative">
          {/* Subtle background glow grid overlay */}
          <div className="absolute inset-0 bg-[linear-gradient(to_right,#06b6d410_1px,transparent_1px),linear-gradient(to_bottom,#06b6d410_1px,transparent_1px)] bg-[size:2rem_2rem] pointer-events-none"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 relative z-10">

            {categories.map((cat) => {
              // Filter items for this category
              const items = HARDWARE_ITEMS.filter(item => item.type === cat);
              if (items.length === 0) return null;

              return (
                <div key={cat} className="space-y-5">
                  {/* Category Header with glowing underline */}
                  <h3 className="text-cyan-400 font-black uppercase text-sm tracking-[0.3em] mb-5 pb-3 border-b-2 border-cyan-500/50 drop-shadow-[0_2px_8px_rgba(6,182,212,0.4)] flex items-center gap-3">
                    {getIcon(cat)} {cat.toUpperCase()}
                  </h3>

                  {items.map((item) => {
                    const isOwned = inventory.includes(item.id);
                    const isEquipped = equipped[item.type] === item.id;

                    const basePrice = item.cost;
                    const finalPrice = Math.floor(basePrice * (1 - (discount || 0)));
                    const canAfford = balance >= finalPrice;

                    return (
                      <div
                        key={item.id}
                        // Intensified borders and hover glows on cards
                        className={`relative p-4 rounded-2xl border-2 transition-all group duration-300
                          ${isEquipped
                            ? 'bg-cyan-950/40 border-cyan-400 shadow-[0_0_35px_rgba(6,182,212,0.5)]' // Stronger equipped glow
                            : 'bg-[#0a0a0f] border-cyan-500/10 hover:border-cyan-400/80 hover:bg-cyan-950/20 hover:shadow-[0_0_25px_rgba(6,182,212,0.3)]'} // Brighter hover glow
                        `}
                      >
                        {/* Item Details */}
                        <div className="flex justify-between items-start mb-4">
                          <div className="flex items-center gap-4">
                            <div className={`p-3 rounded-xl border transition-all ${isEquipped ? 'bg-cyan-500 text-black border-cyan-400 shadow-[0_0_15px_rgba(6,182,212,0.6)]' : 'bg-black/60 text-cyan-600/70 border-cyan-500/20 group-hover:border-cyan-400/50 group-hover:text-cyan-400'}`}>
                              {getIcon(item.type)}
                            </div>
                            <div>
                              <div className={`font-black text-base uppercase tracking-wider transition-all ${isEquipped ? 'text-white drop-shadow-[0_0_5px_rgba(255,255,255,0.5)]' : 'text-cyan-100 group-hover:text-white'}`}>
                                {item.name}
                              </div>
                              <div className="text-xs text-cyan-300/70 font-mono mt-1 group-hover:text-cyan-200">
                                <span className="text-cyan-500 font-bold">Effect:</span> {item.effect}
                              </div>
                            </div>
                          </div>
                          {isEquipped && <CheckCircle className="text-cyan-400 w-6 h-6 drop-shadow-[0_0_10px_rgba(6,182,212,1)]" />}
                        </div>

                        {/* Footer / Actions */}
                        <div className="mt-4 flex justify-between items-center pt-3 border-t border-cyan-500/10 group-hover:border-cyan-500/30 transition-all">
                          <div className="text-[10px] font-black font-mono text-cyan-600/80 uppercase tracking-wider bg-black/40 px-3 py-1.5 rounded-lg border border-cyan-900/30 group-hover:border-cyan-500/30 transition-all">
                            Tier {item.tier} Module
                          </div>

                          {isOwned ? (
                            <button
                              onClick={() => onEquip(item)}
                              disabled={isEquipped}
                              // Added border glow to EQUIP button
                              className={`px-6 py-2 rounded-xl text-xs font-black uppercase tracking-widest transition-all border-2
                                ${isEquipped
                                  ? 'bg-transparent border-cyan-900/30 text-cyan-700 cursor-default'
                                  : 'bg-cyan-950/50 border-cyan-500/50 hover:bg-cyan-400 hover:border-cyan-300 hover:text-black text-cyan-300 shadow-[0_0_15px_rgba(6,182,212,0.2)] hover:shadow-[0_0_30px_rgba(6,182,212,0.6)]'}
                              `}
                            >
                              {isEquipped ? 'INSTALLED' : 'EQUIP'}
                            </button>
                          ) : (
                            <button
                              onClick={() => onBuy(item, finalPrice)}
                              disabled={!canAfford}
                              // Added border glow to BUY button
                              className={`px-6 py-2 rounded-xl text-xs font-black uppercase tracking-widest flex items-center gap-2 transition-all border-2
                                ${canAfford
                                  ? 'bg-yellow-600/90 border-yellow-400 hover:bg-yellow-400 hover:border-yellow-200 text-black shadow-[0_0_20px_rgba(234,179,8,0.4)] hover:shadow-[0_0_40px_rgba(234,179,8,0.7)]'
                                  : 'bg-slate-900 border-slate-800 text-slate-600 cursor-not-allowed opacity-70'}
                              `}
                            >
                              {!canAfford && <Lock size={12} />}
                              {discount > 0 ? (
                                <div className="flex flex-col items-end leading-none">
                                  <span className="line-through text-[9px] opacity-50">${basePrice.toLocaleString()}</span>
                                  <span>${finalPrice.toLocaleString()}</span>
                                </div>
                              ) : (
                                <span>${finalPrice.toLocaleString()}</span>
                              )}
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}

          </div>
        </div>

      </div>
    </div>
  );
};

export default HardwareShop;